(() => {
  const instances = new Map();
  function mount(root) {
    if (instances.has(root.id)) instances.get(root.id)();
    const prose = root.querySelector('[data-jr-prose]');
    const toc = root.querySelector('[data-jr-toc]');
    const progress = root.querySelector('[data-jr-progress]');
    const headings = prose ? [...prose.querySelectorAll('h2')] : [];
    if (toc) {
      toc.replaceChildren();
      headings.forEach((heading, index) => {
        heading.id = `${root.id}-heading-${index + 1}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        toc.append(item);
      });
      root.querySelector('[data-jr-toc-box]').hidden = headings.length === 0;
    }
    const links = toc ? [...toc.querySelectorAll('a')] : [];
    const header = document.querySelector('header.header, .shopify-section-header, [data-header-wrapper], header');
    root.style.setProperty('--jr-sticky-top', `${Math.max(76, (header?.getBoundingClientRect().height || 0) + 20)}px`);
    let scheduled = false;
    function update() {
      scheduled = false;
      if (!prose) return;
      const rect = prose.getBoundingClientRect();
      const range = Math.max(1, rect.height - innerHeight * 0.5);
      if (progress) progress.style.width = `${Math.min(1, Math.max(0, -rect.top / range)) * 100}%`;
      let current = -1;
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--jr-sticky-top')) || 140;
      headings.forEach((heading, index) => { if (heading.getBoundingClientRect().top < offset + 60) current = index; });
      links.forEach((link, index) => {link.classList.toggle('on', index === current); if (index === current) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current');});
    }
    function scroll() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
    function navigate(event) {
      const link = event.target.closest('[data-jr-toc] a');
      if (!link) return;
      const target = headings.find(heading => `#${heading.id}` === link.hash);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
      target.tabIndex = -1;
      target.focus({preventScroll: true});
      history.replaceState(null, '', link.hash);
    }
    root.addEventListener('click', navigate);
    window.addEventListener('scroll', scroll, {passive: true});
    window.addEventListener('resize', scroll, {passive: true});
    update();
    instances.set(root.id, () => {root.removeEventListener('click', navigate); window.removeEventListener('scroll', scroll); window.removeEventListener('resize', scroll); instances.delete(root.id);});
  }
  document.querySelectorAll('.kpt-jr').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.kpt-jr').forEach(mount));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.kpt-jr').forEach(root => instances.get(root.id)?.()));
})();
